export const SoundtrackMapping = Object.freeze({
    embedUrl: 'specific.sound.embedUrl'
});
